import { Radio } from '@sgcmpteltd/uikit-react';
import type { ChangeEventHandler } from 'react';
import { useState } from 'react';

import type {
  ChoiceValue,
  FilterChoice,
  FilterRange,
  RangeValue,
} from '../../../filter-label-list/types';
import { isCategoryChoice, isCategoryRange } from '../../utils';
import { Choice } from '../choice';
import { Range } from '../range';
import styles from './styles.module.scss';
import type { Component } from './types';

export const ConditionSelect: Component = ({
  name,
  selectOption,
  optionValue,
  condition,
  extraInputs,
  extraValues,
  extraOnChange,
  defaultConditionIndex,
  onChange,
}) => {
  const [
    conditionIndex,
    setConditionIndex,
  ] = useState(defaultConditionIndex || 0);

  // const handleSelectChange = (v: string | number) => {
  //   const option = selectOption.optionList.find(opt => opt.value === v);

  //   selectOption.onChange?.(v);
  //   onChange?.({
  //     name,
  //     type: 'select',
  //     optionValue: {
  //       text: option?.text || '',
  //       value: option?.value || '',
  //     },
  //   });
  //   setConditionIndex(condition(v));
  // };
  const handleChange: ChangeEventHandler<HTMLInputElement> = (
    e,
  ) => {
    const option = selectOption.optionList.find(
      opt => opt.value === e.target.value,
    );

    selectOption.onChange?.(
      e.target.value,
    );
    onChange?.({
      name,
      type: 'select',
      optionValue: {
        text: option?.text || '',
        value: option?.value || '',
      },
    });
    setConditionIndex(condition(e.target.value));
  };

  return (
    <div>
      <div className={styles.containerSelect}>
        <Radio
          checked={
            optionValue.value === (selectOption.placeholder?.value ?? '')
          }
          id={selectOption.placeholder?.text || 'Any'}
          label={selectOption.placeholder?.text || 'Any'}
          name={name}
          value={selectOption.placeholder?.value || ''}
          onChange={handleChange} />
        {selectOption.optionList.map(option => (
          <Radio
            key={option.value}
            checked={optionValue.value === option.value}
            id={option.text}
            label={option.text}
            name={name}
            value={option.value}
            onChange={handleChange} />
        ))}
      </div>
      {extraInputs[conditionIndex].map((input, i) => {
        if (isCategoryChoice(input)) {
          const {
            name: extraChoiceName,
            selectOption: extraSelectOption,
            inputOption,
          } = input;

          return (
            <div
              key={extraChoiceName}
              className={styles.containerChoiceName}>
              <span className={styles.textExtra}>
                {extraChoiceName}
              </span>
              <div className={styles.containerChoice}>
                <Choice
                  inputOption={inputOption}
                  inputValue={
                    (extraValues[conditionIndex][i] as ChoiceValue).inputValue
                  }
                  name={extraChoiceName}
                  optionValue={
                    (extraValues[conditionIndex][i] as ChoiceValue).optionValue
                  }
                  selectOption={extraSelectOption}
                  onChange={
                    extraOnChange[conditionIndex][i] as ((
                      (value: FilterChoice) => void))
                  } />
              </div>
            </div>
          );
        }

        if (isCategoryRange(input)) {
          const {
            name: extraRangeName,
            lowerSelectOption,
            upperSelectOption,
          } = input;

          return (
            <div
              key={extraRangeName}
              className={styles.containerChoiceName}>
              <span className={styles.textExtra}>
                {extraRangeName}
              </span>
              <div className={styles.containerChoice}>
                <Range
                  lowerSelectOption={lowerSelectOption}
                  lowerValue={
                    (extraValues[conditionIndex][i] as RangeValue).lowerValue
                  }
                  name={extraRangeName}
                  upperSelectOption={upperSelectOption}
                  upperValue={
                    (extraValues[conditionIndex][i] as RangeValue).upperValue
                  }
                  onChange={
                    extraOnChange[conditionIndex][i] as ((
                      (value: FilterRange) => void))
                  } />
              </div>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
};
